import { useSiteSettings } from "@/hooks/useSiteSettings";
import { useMetaPixel, MetaPixelEvents } from "@/hooks/useMetaPixel";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface CTAButtonProps {
  className?: string;
  children?: React.ReactNode;
  variant?: "default" | "large";
}

const CTAButton = ({ className, children, variant = "default" }: CTAButtonProps) => {
  const { data: settings } = useSiteSettings();
  const { trackEvent } = useMetaPixel();

  const handleClick = () => {
    // Track InitiateCheckout event
    trackEvent(MetaPixelEvents.INITIATE_CHECKOUT, {
      content_name: "3D STL Bundle",
      content_category: "Digital Product",
      value: settings?.sale_price || "$14.00",
      currency: "USD",
    });

    // Redirect to checkout
    if (settings?.checkout_url) {
      window.open(settings.checkout_url, "_blank");
    }
  };

  return (
    <Button
      onClick={handleClick}
      className={cn(
        "bg-cta hover:bg-cta/90 text-cta-foreground font-bold uppercase tracking-wider shadow-lg hover:shadow-xl transition-all duration-300 rounded-xl px-10 py-5 text-base",
        variant === "large" && "text-xl py-7 px-12",
        className
      )}
    >
      {children || "ADD TO CART & GET INSTANT ACCESS"}
    </Button>
  );
};

export default CTAButton;
